import React from "react";
import ReactMarkdown from "react-markdown";
import { ReactComponent as NovaIcon } from "resources/icons/nova.svg";
import NovaDislikeButtonModal from "./NovaDislikeButtonModal";
import CopyLikeDislikeIcons from "DesignSystem/CopyLikeDislike";
import useNovaAiMessageBubble from "./hooks/useNovaMessageBubble";

const MessageBubble = React.forwardRef((props, ref) => {
  const {
    messageText,
    showUserMessage,
    isAiLoading,
    aiResponse,
    sendNovaChatFeedback,
    conversationId,
    aiMessageId,
    alwaysShowIcons,
    isDraggedToEdge,
    dir,
  } = props;
  const {
    hovered,
    copyTooltipVisible,
    likeTooltipVisible,
    dislikeTooltipVisible,
    dislikeModalOpen,
    reaction,
    handleCopy,
    handleLike,
    handleDislike,
    handleSubmitFeedback,
    handleCancelFeedback,
    handleMouseEnter,
    handleMouseLeave,
    setDislikeModalOpen,
  } = useNovaAiMessageBubble({
    sendNovaChatFeedback,
    conversationId,
    aiResponse,
    aiMessageId,
  });

  return (
    <div ref={ref} className="message-bubble">
      {showUserMessage && (
        <div
          className="user-message-bubble"
          dangerouslySetInnerHTML={{ __html: messageText }}
        />
      )}
      {aiResponse && (
        <div className="bot-message-wrapper">
          {!isAiLoading && (
            <NovaIcon className="display-inline nova-response-icon-chat" />
          )}
          <div
            className="ai-response-bubble"
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            <ReactMarkdown>{aiResponse.text}</ReactMarkdown>
            <div className="flex bubble-icons-wrapper">
              {(hovered || alwaysShowIcons) && (
                <CopyLikeDislikeIcons
                  reaction={reaction}
                  handleCopy={handleCopy}
                  handleLike={handleLike}
                  handleDislike={handleDislike}
                  copyTooltipVisible={copyTooltipVisible}
                  likeTooltipVisible={likeTooltipVisible}
                  dislikeTooltipVisible={dislikeTooltipVisible}
                />
              )}
            </div>
          </div>
        </div>
      )}
      {dislikeModalOpen && (
        <NovaDislikeButtonModal
          visible={dislikeModalOpen}
          setDislikeModalOpen={setDislikeModalOpen}
          newConversationId={conversationId}
          sendNovaChatFeedback={sendNovaChatFeedback}
          messageId={aiMessageId}
          npsScore={0}
          handleSubmitFeedback={handleSubmitFeedback}
          handleCancelFeedback={handleCancelFeedback}
          isDraggedToEdge={isDraggedToEdge}
          dir={dir}
        />
      )}
    </div>
  );
});
MessageBubble.displayName = "MessageBubble";

export default MessageBubble;
